import { flexCascade } from 'app/constants/Styles';
import { createStyles } from 'app/utils/css';
import React, { ReactNode } from 'react';

export interface IPageWidthProps {
  children: ReactNode;
  maxWidth: '1200px' | '792px' | '396px';
}

const PageWidth = ({ children, maxWidth }: IPageWidthProps) => (
  <Styles>{(css) =>
    <div className={css('pageWidth')} style={{ maxWidth }}>
      {children}
    </div>
  }</Styles>
);

const Styles = createStyles({
  pageWidth: {
    ...flexCascade,
    margin: '0 auto',
    width: '100%',
  },
});

export default PageWidth;
